import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintEdi_ds_get_adjustment_taskIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { hasTransmissions?: boolean, project?: string, warehouse?: string, modifiedFrom?: string, modifiedTo?: string, material?: string, taskIds?: number[], take?: number, operationTypeIds?: number[], operationCodes?: string[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, OperationCode?: { OperationTypeId?: number } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { hasTransmissions?: boolean, project?: string, warehouse?: string, modifiedFrom?: string, modifiedTo?: string, material?: string, taskIds?: number[], take?: number, operationTypeIds?: number[], operationCodes?: string[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, OperationCode?: { OperationTypeId?: number } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { hasTransmissions?: boolean, project?: string, warehouse?: string, modifiedFrom?: string, modifiedTo?: string, material?: string, taskIds?: number[], take?: number, operationTypeIds?: number[], operationCodes?: string[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, OperationCode?: { OperationTypeId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      hasTransmissions?: boolean, project?: string, warehouse?: string, modifiedFrom?: string, modifiedTo?: string, material?: string, taskIds?: number[], take?: number, operationTypeIds?: number[], operationCodes?: string[]    }) {
      return false;
    }
}
